define('app/views/travel_residence_checkout_view',['app/setup'],
  function(takhfifan) {
    takhfifan.travelResidenceCheckout = Backbone.View.extend({
      events: {
        'submit .tkh-travel-hotel-passengers-form' : 'submitForm',
        'submit .tkh-travel-offline-hotel-passengers-form' : 'submitOfflineHotelForm',
      },

      template: ( $('#travel-residence-checkout-cart').length > 0 ) ?
        _.template( $('#travel-residence-checkout-cart').html() ) : '',

      initialize: function () {
        this.saveOrderPath = this.$el.data('saveOrderUrl');

        takhfifan.eventHub.on('travel:viewChanged', function (options) {
          if(options.view==="residence-cart"){
            this.initForm();
          }
        }, this);

        $(document).on('change invalid','.tkh-travel-form-input', function() {
          if($(this).prop('type')==='radio'){
            return;
          }
          var inputField = $(this).get(0);

          inputField.setCustomValidity('');

          if (!inputField.validity.valid) {
            var fieldName = $(this).prop('placeholder');
            inputField.setCustomValidity('لطفا ' + fieldName + ' را وارد کنید');
          }
        });
      },

      initForm: function () {
        var persistedData = Lockr.get('travelHotelData'),
          dataUpdatedTime = (persistedData && persistedData.time) || undefined;

        if(!persistedData || !persistedData.hotels || !persistedData.search || !persistedData.cart || !persistedData.time){
          this.showFailedCart();
          return;
        }

        if(dataUpdatedTime){
          var currentTime = new Date();
          if(currentTime - persistedData.time > 15*60*1000){
            Lockr.set("travelHotelData", {});
            this.showFailedCart();
            return;
          }
        }
        this.$el.html(this.template({search: persistedData.search, cart: persistedData.cart, message:false}));
      },

      showFailedCart: function(message){
        this.$el.html(this.template({message:message || 'سبد شما خالی است.' }));
      },

      submitForm: function (e) {
        e.preventDefault();
        takhfifan.eventHub.trigger('travel:disable');
        var formData = this.gatherPassengersData();
        var _this = this;
        $.ajax({
          type: 'POST',
          url: _this.saveOrderPath,
          data: formData
        }).done(function (data) {
          if (data.result == 'failed') {
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: data.message || "خطایی در برقراری ارتباط پیش آمد."
            });
            takhfifan.eventHub.trigger('travel:enable');
            _this.showFailedCart('در برقراری ارتباط با سرور مشکلی پیش آمد. لطفا مجددا جستجو کنید');
          } else {
            takhfifan.eventHub.trigger('message:show', {
              type: 'success',
              msg: data.message || "اطلاعات شما ثبت شد، کارشناسان ما با شما تماس خواهند گرفت"
            });
            takhfifan.eventHub.trigger('travel:enable');
            _this.showFailedCart("اطلاعات شما ثبت شد، کارشناسان ما با شما تماس خواهند گرفت");
          }
        }).fail(function () {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: 'عملیات با خطا مواجه شد.'
          });
          _this.showFailedCart('در برقراری ارتباط با سرور مشکلی پیش آمد. لطفا مجددا جستجو کنید');
          takhfifan.eventHub.trigger('travel:enable');
        }).complete(function(){
          Lockr.set('travelHotelData','');
        });
      },

      submitOfflineHotelForm: function (e) {
        e.preventDefault();
        takhfifan.eventHub.trigger('travel:disable');
        var formData = this.gatherCustomerData();
        var _this = this;
        $.ajax({
            type: 'POST',
            url: '/ajax/forms/saveOfflineHotel',
            data: formData
        }).done(function (data) {
        if (data.result == 'failed') {
            takhfifan.eventHub.trigger('message:show', {
                type: 'error',
                msg: data.message || "خطایی در برقراری ارتباط پیش آمد."
            });
            takhfifan.eventHub.trigger('travel:enable');
            _this.showFailedCart('در برقراری ارتباط با سرور مشکلی پیش آمد. لطفا مجددا جستجو کنید');
        } else {
            takhfifan.eventHub.trigger('message:show', {
                type: 'success',
                msg: data.message || "اطلاعات شما ثبت شد، کارشناسان ما با شما تماس خواهند گرفت"
            });
            takhfifan.eventHub.trigger('travel:enable');
            _this.showFailedCart("اطلاعات شما ثبت شد، کارشناسان ما با شما تماس خواهند گرفت");
        }
    }).fail(function () {
        takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: 'عملیات با خطا مواجه شد.'
        });
        _this.showFailedCart('در برقراری ارتباط با سرور مشکلی پیش آمد. لطفا مجددا جستجو کنید');
        takhfifan.eventHub.trigger('travel:enable');
    }).complete(function(){
        Lockr.set('travelHotelData','');
    });

      },

      gatherCustomerData: function () {
          var persistedData = Lockr.get('travelHotelData');
          return {
              formKey: takhfifan.formKey,
              firstname: this.$('input[name="firstName"]').val(),
              lastname: this.$('input[name="lastName"]').val(),
              email: this.$('input[name="email"]').val(),
              mobile: this.$('input[name="mobile"]').val(),
              tel: this.$('input[name="tel"]').val(),
              desc: this.$('input[name="desc"]').val(),
              checkin: persistedData.search.checkin,
              night: persistedData.search.nights,
              parentId: persistedData.cart.parentId,
              cityName: persistedData.search.cityName,
              parentName: persistedData.cart.name,
              details: persistedData.cart.details
          };
      },

      gatherPassengersData: function () {
        var persistedData = Lockr.get('travelHotelData');
        return {
          formKey: takhfifan.formKey,
          firstname: this.$('input[name="firstName"]').val(),
          lastname: this.$('input[name="lastname"]').val(),
          email: this.$('input[name="email"]').val(),
          mobile: this.$('input[name="mobile"]').val(),
          tel: this.$('input[name="tel"]').val(),
          desc: this.$('input[name="desc"]').val(),
          checkin: persistedData.search.checkin,
          night: persistedData.search.nights,
          parentId: persistedData.cart.parentId,
          details: persistedData.cart.details
        };
      }

    })
  });

